import {injectable} from "inversify";
import {UserApi} from "@intelingu/core/api/UserApi";
import {UserStore} from "@intelingu/core/stores/UserStore";
import {SubscriptionStore} from "@intelingu/core/stores/SubscriptionStore";
import {CourseStore} from "@intelingu/core/stores/CourseStore";
import {AppStore} from "./AppStore";
import {action, observable} from "mobx";

declare const fbq;

@injectable()
export class BootstrapStore {

    @observable isLoaded = false;
    skipFirstLoad = true;
    fbInitialized = false;

    constructor(
        private userApi: UserApi,
        private userStore: UserStore,
        private subscriptionStore: SubscriptionStore,
        private courseStore: CourseStore,
        private appStore: AppStore,
    ) {
    }

    @action async bootstrap() {
        const bootstrapData = await this.userApi.bootstrap();

        if (bootstrapData) {
            this.userStore.user = bootstrapData.data.user;
            this.userStore.userUpdatedDate = new Date();

            if (!this.fbInitialized) {
                this.fbInitialized = true;

                if (typeof fbq !== 'undefined') {
                    fbq('init', '214474016398371', {
                        em: this.userStore.user.email,
                        fn: this.userStore.user.first_name
                    });
                }
            }

            this.subscriptionStore.subscriptions = bootstrapData.data.subscriptions;
            this.courseStore.coursesList = bootstrapData.data.courses;
            this.userStore.progress = bootstrapData.data.progress;
            this.userStore.achievements = bootstrapData.data.achievements;
            this.courseStore.currentCourse = bootstrapData.data.courses.filter(
                (item) => item.id === bootstrapData.data.current_course
            )[0];

            this.userStore.isReady = true;

            if (!bootstrapData.data.tutorial || this.userStore.user.tour_step === 'finished') {
                this.appStore.tourFinished = true;
            } else {
                this.appStore.tourParentIndex = this.userStore.user.tour_step as number || 0;

                if (bootstrapData.data.tutorial) {
                    await this.appStore.initTour(bootstrapData.data.tutorial);
                }
            }

            this.isLoaded = true;
            console.log('set loaded');
        }
    }

}
